import type { SearchContext } from '@shared/types/types.ts';

/**
 *
 *
 */
const ASSORTMENTS_WITH_INSTALLMENTS = [
    'Fahrzeuge',
    'Gartengeräte',
    'Kommunikation',
    'Pools',
    'Unterhaltungselektronik',
    'Gebäude',
    'Optik',
    'Reinigungsgeräte',
    'Haushaltsgeräte',
] as const;

/**
 *
 */
const SEARCHTERMS_WITH_INSTALLMENTS = [
    'AirPods',
    'AirPods 4',
    'AirPods Pro',
    'AirPods Pro 2',
    'AirPods Pro 3',
    'AirPods Series 4',
    'AirTag',
    'Apple',
    'Apple Airpods',
    'Apple AirPods Pro',
    'Apple iMac',
    'Apple iPad',
    'Apple iPad Air',
    'Apple iPad Pro',
    'Apple iPhone',
    'Apple iPhone 13',
    'Apple iPhone 14',
    'Apple iphone 15',
    'Apple iPhone 16',
    'Apple iPhone 17',
    'Apple laptop',
    'Apple Macbook',
    'Apple Macbook Air',
    'Apple Macbook Pro',
    'Apple Magic Keyboard',
    'Apple Pencil',
    'Apple Pencil 2',
    'Apple Pencil 3',
    'Apple tablet',
    'Apple TV',
    'Apple Watch',
    'Apple Watch 8',
    'Apple Watch 9',
    'Apple Watch 10',
    'Apple Watch 11',
    'Apple Watch armband',
    'Apple Watch SE',
    'Apple Watch Series 10',
    'Apple Watch Series 11',
    'Apple Watch Ultra',
    'Apple Watch Ultra 2',
    'Apple Watch Ultra 3',
    'HomePod',
    'HomePod mini',
    'iMac',
    'iPad',
    'iPad 2021',
    'iPad 2022',
    'iPad 2024',
    'iPad 2025',
    'iPad 9',
    'iPad 9 generation',
    'iPad 9th gen',
    'iPad 10',
    'iPad 10 generation',
    'iPad 10th gen',
    'iPad Air',
    'iPad Air 2020',
    'iPad Air 2022',
    'iPad Air 2024',
    'iPad Air 2025',
    'iPad Air 5',
    'iPad Air M2',
    'iPad Air M3',
    'iPad Apple',
    'iPad mini',
    'iPad mini 6',
    'iPad mini 7',
    'iPad Pro',
    'iPad Pro 11',
    'iPad Pro 12.9',
    'iPad Pro 13',
    'iPad Pro 2021',
    'iPad Pro 2022',
    'iPad Pro 2024',
    'iPad Pro 2025',
    'iPad stift',
    'iPad tastatur',
    'iPhone',
    'iPhone 12',
    'iPhone 13',
    'iphone 13 256gb',
    'iPhone 13 grün',
    'iPhone 13 mini',
    'iPhone 14',
    'iPhone 14 Pro',
    'iphone 14 Pro 256gb',
    'iPhone 14 Pro Max',
    'iphone 14 Pro max 256gb',
    'iPhone 15',
    'iPhone 15 plus',
    'iPhone 15 Pro',
    'iphone 15 Pro max',
    'iPhone 16 Plus',
    'iPhone 16 Pro Max',
    'iPhone 16 Pro',
    'iPhone 16',
    'iPhone 17 Pro Max',
    'iPhone 17 Pro',
    'iPhone 17',
    'iPhone Air',
    'iPhone SE',
    'iPhone SE 2022',
    'iPhone SE 3',
    'Mac mini',
    'Macbook',
    'Macbook Air',
    'Macbook Air 2022',
    'Macbook Air M1',
    'Macbook Air M2',
    'MacBook Air M3',
    'MacBook Air M4',
    'Macbook Pro',
    'Macbook Pro 14',
    'Macbook Pro 2022',
    'Macbook Pro m1',
    'Macbook Pro m2',
    'MacBook Pro M2',
    'MacBook Pro M3',
    'MacBook Pro M4',
    'Magic Keyboard',
    'neues iPhone',
] as const;

const ASSORTMENTS_SET = new Set(ASSORTMENTS_WITH_INSTALLMENTS.map((item) => item.toLowerCase()));
const SEARCHTERMS_SET = new Set(SEARCHTERMS_WITH_INSTALLMENTS.map((item) => item.toLowerCase()));

export function shouldShowInstallments(searchContext?: SearchContext): boolean {
    const { searchTerm, assortment } = searchContext ?? {};

    return !!(
        (searchTerm && SEARCHTERMS_SET.has(searchTerm.toLowerCase())) ||
        (assortment && ASSORTMENTS_SET.has(assortment.toLowerCase()))
    );
}
